import React from "react";
// import "./productDetailsMain.css";

class ProductCarousel extends React.Component {
  state = {
    photos: [],
    active: 0,
    zoomDisplay: "",
    PageX: 0,
    PageY: 0,
    isMobile: false,
  };

  componentDidMount() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  }

  checkMobile = () => {
    this.setState({
      isMobile: window.innerWidth < 992, // Disable zoom on screens smaller than 992px
    });
  };

  static getDerivedStateFromProps({ media }, prevState) {
    let photos = ["http://placecorgi.com/600/600"];

    if (media && media.length) {
      photos = media.map((photoObj) => photoObj);
    }

    // Only update photos if they've changed
    if (JSON.stringify(photos) !== JSON.stringify(prevState.photos)) {
      return { photos };
    }

    return null;
  }

  handleIndexClick = (event) => {
    const index = event.currentTarget.dataset.index;
    this.setState({
      active: +index,
    });
  };

  handleMouseOver = (event) => {
    // Only enable zoom on desktop
    if (!this.state.isMobile) {
      this.setState({
        zoomDisplay: "block",
      });
    }
  };

  handleMouseLeave = (event) => {
    this.setState({
      zoomDisplay: "",
      PageX: 0,
      PageY: 0,
    });
  };

  handleMouseMove = (event) => {
    // Only calculate zoom position on desktop
    if (!this.state.isMobile && this.state.zoomDisplay) {
      const { left, top, width, height } = event.target.getBoundingClientRect();
      const scrollPos = window.pageYOffset;

      const x = ((event.pageX - left) / width) * 100;
      const y = ((event.pageY - scrollPos - top) / height) * 100;

      this.setState({
        PageX: x,
        PageY: y,
      });
    }
  };

  handleTouchStart = (event) => {
    // Prevent zoom behavior on touch devices
    event.preventDefault();
  };

  render() {
    const { photos, active, zoomDisplay, PageX, PageY } = this.state;

    return (
      <>
        <div className="product-carousel-image-container">
          <img
            className="img-fluid w-100"
            onMouseOver={this.handleMouseOver}
            onMouseLeave={this.handleMouseLeave}
            onMouseMove={this.handleMouseMove}
            onTouchStart={this.handleTouchStart}
            src={photos[active]?.large || photos[0]?.large}
            alt="Product"
            loading="lazy"
          />
          <div style={{ display: zoomDisplay }} className="zoom">
            <img
              style={{
                transform: `translate3d(${-PageX + 20}%, ${-PageY + 20}%, 0px)`,
              }}
              src={photos[active]?.full || photos[active]?.large}
              alt="Product Zoom"
            />
          </div>
        </div>

        <div className="navigator-container">
          <div className="container">
            <div className="row gx-2">
              {photos.map((photo, index) => (
                <div 
                  key={`thumb-${index}`} 
                  className="col-6 col-sm-4 col-md-3"
                >
                  <div className="w-100">
                    <img
                      onClick={this.handleIndexClick}
                      data-index={index}
                      className={`img-fluid w-100 ${
                        index === active ? "active" : ""
                      }`}
                      src={photo.large}
                      alt={`Product thumbnail ${index + 1}`}
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ProductCarousel;